// Sibling-host URL derivation — a pure mirror of
// `src/condense/hosts.py:sibling`. Strips the leading service-name
// subdomain (helm/login/api/cli/admin/landing), prefixes the requested
// service, and preserves protocol + port. A single build works across
// every deployment domain — change the zone, no code edit needed.

type Service = "api" | "helm" | "cli" | "login";

const KNOWN_SERVICES = new Set([
  "api",
  "admin",
  "cli",
  "helm",
  "login",
  "landing",
]);

export function zoneOf(hostname: string): string {
  const h = hostname.toLowerCase();
  const dot = h.indexOf(".");
  if (dot === -1) return h;
  const first = h.slice(0, dot);
  const rest = h.slice(dot + 1);
  return KNOWN_SERVICES.has(first) ? rest : h;
}

export function sibling(service: Service): string {
  const proto = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : "";
  return `${proto}//${service}.${zoneOf(window.location.hostname)}${port}`;
}

export const apiUrl = (): string => sibling("api");
export const loginUrl = (): string => sibling("login");
export const cliUrl = (): string => sibling("cli");

// Landing serves at the bare apex, not landing.<zone>.
export function landingUrl(): string {
  const proto = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : "";
  return `${proto}//${zoneOf(window.location.hostname)}${port}`;
}
